import { render, staticRenderFns } from "./InvoiceSettlement.vue?vue&type=template&id=524973de&scoped=true"
import script from "./InvoiceSettlement.vue?vue&type=script&lang=js"
export * from "./InvoiceSettlement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524973de",
  null
  
)

export default component.exports
import QPopupEdit from 'quasar/src/components/popup-edit/QPopupEdit.js';
import QField from 'quasar/src/components/field/QField.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPopupEdit,QField,QInput,QIcon,QPopupProxy,QDate,QBtn});qInstall(component, 'directives', {ClosePopup});
